export const BASE_PATH_LOGO = 'api/App/documents/';

export const BASE_WIDTH_LOGO = 100;
export const BASE_HEIGHT_LOGO = 100;

export const BASE_WIDTH_HEADER_LOGO = 240;
export const BASE_HEIGHT_HEADER_LOGO = 80;
